<script setup lang="ts">
import ToggleButton from 'primevue/togglebutton';
import { globalKeys } from 'assets/data/global-keys';

const { $storageService } = useServices();
const enabled = ref<boolean>(false);

const toggleDebug = (value: boolean) => {
  enabled.value = value;
  if (value)
    $storageService.setSessionStorage({
      key: globalKeys.developerConfigKeys.debugDisableCache,
      data: true,
    });
  else
    $storageService.removeSessionStorage({
      key: globalKeys.developerConfigKeys.debugDisableCache,
    });
};

const clearApiCache = inject('clearApiCache');

onMounted(() => {
  enabled.value = !!$storageService.getSessionStorage({
    key: globalKeys.developerConfigKeys.debugDisableCache,
  });
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <p class="text-xs text-base-priority my-1">
      In order to disable existing api caching, you need to toggle the button
      below. This will also log the cache hits to the console for debugging.
    </p>
    <ToggleButton
      on-label="Cache disable on"
      off-label="Cache disable off"
      class="p-2 rounded-lg std-border text-sm truncate"
      :class="[
        {
          'bg-base text-base-priority stacked-border': !enabled,
          'bg-success-500 text-light-50 font-bold': enabled,
        },
      ]"
      :model-value="enabled"
      @change="toggleDebug(!enabled)"
    />
    <DesignSystemButton @click="clearApiCache">Clear Cache</DesignSystemButton>
  </div>
</template>
